import { useState } from "react";
import { EmailUrl, KlaviyoAPIUrl } from "../constants";

const useSendEmail = () => {
  const [userEmail, setUserEmail] = useState("");

  const addUserEmail = (email) => {
    setUserEmail(email);
  };

  const sendEmail = (language, apiToken) => {
    if (userEmail === "") return;

    try {
      fetch(`${EmailUrl}?lng=${language}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: apiToken,
        },
        body: JSON.stringify({ email: userEmail }),
      });
    } catch (error) {}
  };

  const sendResultsToKlaviyo = async (apiToken, isNLUser) => {
    try {
      const klaviyoResponse = await fetch(
        `${KlaviyoAPIUrl}?lng=${isNLUser ? "nl" : "de"}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: apiToken,
          },
          method: "POST",
        },
      );
      if (klaviyoResponse.ok) {
        return true;
      }
    } catch (error) {
      console.error("Klaviyo failed due to ", error);
      return false;
    }
  };

  return { addUserEmail, sendEmail, sendResultsToKlaviyo };
};

export default useSendEmail;
